// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"63e8c6e2","175":"9c6cdb90","239":"2c268a49","389":"d7fdcdb3","434":"5768fbf7","599":"023b92bf","600":"a03a14f7","803":"e1c13a9f"}[chunkId] + ".chunk.js";
};